import {
  Easing,
  EffectConfig,
  EffectFourCorners,
  EffectParams,
  EffectPower,
  SchemaGroup,
} from '../types';
import {
  allowReplay,
  delay,
  duration,
  directionFourCorners as direction,
  easing,
  power,
} from './baseParams';

export interface TurnIn extends EffectParams {
  direction: EffectFourCorners;
  power?: EffectPower;
  easing?: Easing;
}

const name = 'TurnIn';
const groups: SchemaGroup[] = ['entrance', 'animation'];

export const config: EffectConfig<TurnIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1000 },
    direction: { ...direction, default: 'bottom-left' },
    power: { ...power, default: 'hard' },
  },
} as const;

export const responsiveConfig: EffectConfig<TurnIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1200 },
    direction: { ...direction, default: 'bottom-left' },
    easing: { ...easing, default: 'backOut' },
  },
} as const;
